export default {
    messages: [
        {
            name: 'HPの管理人',
            comment: '松尾中学校の思い出や、来年度から開校する山武望洋中学校への期待の気持ちなど是非書き込んでください。'
        },
        {
            name: '元生徒',
            comment: '松尾中学校ではなくなって悲しいですが、来年度からは蓮沼中の生徒が来て今よりにぎやかになると思います。たくさんの仲間とこれからの山武望洋中学校の未来を創っていってください。'
        },
        {
            name: '青春の場所',
            comment: '名前は変わるかもしれないけど、思い出は消えません。松中で流した汗や涙は確実に僕達を成長させてくれました。青春をありがとう！！！これからもみんなの青春の場でありますように。。。'
        },
        {
            name: 'Nobuhiro',
            comment: '山武望洋中学校という名前にはなれるまでしばらくかかりそうですが、素敵な学校になるよう、応援してます！'
        },
        {
            name: 'T',
            comment: '設備がとても整っている自慢の母校！松尾中の名前が変わるのは悲しいけど素晴らしい中学校があったこと自分たちは忘れません！今まで本当にありがとう！お疲れ様！'
        },
        {
            name: 'M',
            comment: '母校が無くなるのがとても寂しいです。'
        },
        {
            name: '杉山',
            comment: 'この度は松尾中学校閉校される当たりに、心より遺憾に感じます。今思えば私の青春の全てはこの松尾中学校に詰まっていたと、そう思います。入学して右も左も分からないこの私に道を差し伸べて下さった先輩方、時には道を踏み外しそうになった私を正しい道へと導いてくださった先生方、影で私達生徒が健やかに成長出来る環境を維持してくださっていた職員の方々、全ての松尾中学校関係者様に心より感謝申し上げます。松尾中学校閉校に当たりとても寂しく思います。これからの松尾中学校関係者の皆様のご健勝とご多幸を心よりお祈り申し上げます。'
        },
        {
            name: '歯',
            comment: '改めて校舎や設備の写真を見ると本当に整った環境で学校生活を送れていたんだと感銘を受けました。いつまでも設備の整った学校であることを願っています。'
        },
        {
            name: 'キンチョール',
            comment: '写真を見て、もう一度松尾中学校を見てみたくなりました。'
        },
        {
            name: 'MTO',
            comment: '悲しいけどこれも現実。変革なくして創造なし松尾中の名を背負えたことは誇り我らが松尾の名は永遠に、'
        },
        {
            name: 'ピッコロ',
            comment: 'すごく戻りたいなと感じました､､､'
        },
        {
            name: 'バスケ少女',
            comment: '坂がきつくてほんとに大変だったけど、もう登らないのかなって思うと少し寂しいです笑。松尾中じゃなくなっても、松尾中の校舎にたくさんの笑顔があふれかえりますように！たくさんの笑顔・元気を見守っててね！'
        },
        {
            name: 'わたし',
            comment: '母校…'
        },
        {
            name: '卒業生A',
            comment: 'とても懐かしい気持ちになれました！大変だったと思いますが、このようなページをつくってくださってありがとうございます(*´︶`*)'
        },
        {
            name: 'OB',
            comment: '陸上部を復活させましょう。グラウンドが泣いてる！'
        },
        {
            name: '豊岡人',
            comment: '閉校式的なのはやらないのですか?'
        },
        {
            name: '松尾人',
            comment: '閉校式はやるらしいです！'
        },
        {
            name: '山',
            comment: '小野崎校長、松尾中学校の見届けお願いします。'
        },
        {
            name: '卒業生B',
            comment: 'ありがとう、松尾中学校！写真館の写真を見て、とても懐かしい気持ちになりました☺︎'
        },
        {
            name: 'スーさん',
            comment: '名前が変わるんですね❗️閉校と聞いたので、どうなるのかと思いました。私は円型校舎だったので今の建物の画像にはピンときませんが、これからの未来をしょっていく学生に期待していますね。'
        },
        {
            name: '円形校舎',
            comment: '円形校舎は知らぬまになくなっていましたが、松尾中そのものがなくなるとは……自分の人生のなかで、いちばん「楽しい」「苦しい」「キラキラ✨」を体験した場所でした。新しい中学校も、学生たちにとってすばらしい３年間を過ごせる場所になりますように‼'
        },
        {
            name: 'A',
            comment: '閉校式はいつやるのでしょうか？'
        },
        {
            name: 'あぱれる',
            comment: '３月25らししかったです。'
        },
        {
            name: '鈴木',
            comment: '閉校式は3月の下旬でしょうか？'
        },
        {
            name: 'Y',
            comment: '母校の学校が無くなるの寂しい沢山の思い出がある学校生活を送りました。また、母校に行きたかったです'
        },
        {
            name: 'Y',
            comment: '沢山の思い出があった校舎がなくなるの寂しい'
        },
        {
            name: '大平人',
            comment: '私が学んだ松尾中学校は、円型校舎の頃。４階の講堂から見える水平線、富士山、成人式もここで。子は、円型校舎で行う最後の卒業生でした。現在の学舎で学ぶ事はありませんでしたが、孫の学舎に。そして松尾中学校生徒として最後の卒業生に！縁(えにし)を感じます。歴史は松尾中学校から山武望洋中学校へ引き継がれるのですね。さらなる活躍、発展を祈ります。管理人さんへ。円型校舎の姿も写真館に載せていただけたら嬉しいです。そして、明日、挙行される閉校式の様子も是非掲載してほしいです。'
        },
        {
            name: '坂本(弟)ですがなにか。(剣道部)',
            comment: 'そっかァ〜母校無くなっちゃうのかァまぁ、まだ俺がいた時の先生は残ってるっぽいから全然いいやぁこれで、知ってる先生いなくなったらやだなぁ。'
        },
        {
            name: '卒業生',
            comment: 'すごく整った環境で学ぶことができて本当によかったです。思い出がたくさんできました。\n松尾中学校がなくなってしまうのはすごく寂しいですが、山武望洋中も松尾中のような学校になることを願っています…ありがとう、松中！'
        },
        {
            name: '卒業生',
            comment: '我らが松尾の名は永遠に'
        },
        {
            name: 'ありがとう松尾中！',
            comment: '私が学んだのは円形校舎の頃です。今は亡き父も同じ校舎でした。いろいろなことを思い出します。つい最近、通っていた小学校も統合され、校歌が変わっていたことに寂しさをかんじたところでしたので、またかとは思いましたが、音声が聞けてとても懐かしく、卒業してから30年近くたつのに、覚えている自分にもびっくりしました。これから、新しい歴史を刻んでいって欲しいと思います。ありがとうございました。'
        },
    ]
}
